var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenantName)?_c('el-select',{staticClass:"tenant-switch",attrs:{"value":_vm.tenantId,"filterable":"","disabled":!_vm.canSwitchTenant,"size":"mini","placeholder":"请选择租户"},on:{"change":_vm.handleChange}},_vm._l((_vm.tenantsList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }